import cloneDeep from 'lodash/cloneDeep';

var getIn = require('./utils/getIn');
var updateIn = require('./utils/updateIn');

/**
 * Extracted the linkedState implementation to its own function (instead of a mixin)
 *
 * @params {ReactElement} ctx The component's `this`
 * @params {str} path State key to be updated
 * @return {object}
 */
export default function linkState(ctx, path) {
  let clonedState=cloneDeep(ctx.state);
  let val=getIn(clonedState, path);
  return {
    value: val,
    requestChange: function setPartialState(value) {
      ctx.setState(updateIn(
        clonedState,
        path,
        value
      ));
    },
    removeItem:function(filterFnc) {
      if(!val || !val.hasOwnProperty("length")) {
        val=[];
      }

      val=val.filter(filterFnc);
      ctx.setState(updateIn(
        clonedState,
        path,
        val
      ));
    },
    pushItem:function(item){
      let clonedVal=cloneDeep(val);
      if(!clonedVal || !clonedVal.hasOwnProperty("length")) {
        clonedVal=[];
      }

      clonedVal.push(item);
      ctx.setState(updateIn(
        clonedState,
        path,
        clonedVal
      ));
    },
    autoCheckbox:function(){
      return {
        checked:val=='1'?true:false,
        onChange:(e)=>{
          let setVal='';
          if(e.target.checked){
            setVal='1';
          } else {
            setVal='0';
          }
          ctx.setState(updateIn(
            clonedState,
            path,
            setVal
          ));
        }
      }
    },
    auto:function(type=false){
      return {
        value:typeof val === 'undefined'?'':val,
        onChange:(e)=>{
          let setVal=e.target.value;
          if(type) {
            switch(type) {
              case 'int':
                setVal=parseInt(setVal);
                if(isNaN(setVal)) {
                  setVal='';
                }
                break;
              case 'str':
                setVal=setVal+"";
                break;
            }
          }

          ctx.setState(updateIn(
            clonedState,
            path,
            setVal
          ));
        }
      }
    }
  };
}
